// DS: C25A
import React from 'react';
import classnames from 'classnames';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { PopperDropdownManager, PopperDropdownToggle, PopperDropdownContent } from '../../Dropdown/PopperDropdownLayout';
import FolderDropdownDesktopMenu from './FolderDropdownDesktopMenu';
import FolderDropdownDesktopMenuUpdated from './FolderDropdownDesktopMenu.complete_theme';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import LoadingIndicator from '../../LoadingIndicator';
import s from './FolderDropdownDesktop.scss';
const FolderDropdownDesktop = ({ id, folderNameClassNames, currentFolder, arrowIconSize = IconSize.SMALL, className, usePortal, folders, filterEmpty, disabled, setSelectedFolderId, renderToggle, escapeScreenSpace = true, hasMore, fetchMore, isLoading })=>{
    var _currentFolder, _currentFolder1;
    const is_complete_theme = useFlag('complete_theme');
    const MenuComponent = is_complete_theme ? FolderDropdownDesktopMenuUpdated : FolderDropdownDesktopMenu;
    const classNames = classnames(s['root'], 'no-theme-skin', disabled && s['disabled'], className);
    var _currentFolder_totalItemCount, _ref;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        isInPopup: true
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        "data-hook": BiDataHook.PROFILE_GALLECTION_FOLDER_CHOOSER,
        className: s['toggle']
    }, renderToggle ? renderToggle({
        currentFolder
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['selected-folder-name'], folderNameClassNames)
    }, currentFolder && currentFolder.name, /*#__PURE__*/ React.createElement("span", {
        className: s['count']
    }, shortenNumber((_ref = (_currentFolder_totalItemCount = (_currentFolder = currentFolder) === null || _currentFolder === void 0 ? void 0 : _currentFolder.totalItemCount) !== null && _currentFolder_totalItemCount !== void 0 ? _currentFolder_totalItemCount : (_currentFolder1 = currentFolder) === null || _currentFolder1 === void 0 ? void 0 : _currentFolder1.size) !== null && _ref !== void 0 ? _ref : 0))), /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        className: s['caret'],
        size: arrowIconSize
    }))), /*#__PURE__*/ React.createElement(PopperDropdownContent, {
        usePortal: usePortal,
        placement: "bottom-start",
        allowFlip: false
    }, /*#__PURE__*/ React.createElement(MenuComponent, {
        id: id,
        folders: folders,
        filterEmpty: filterEmpty,
        setSelectedFolderId: setSelectedFolderId,
        currentFolder: currentFolder,
        hasMore: hasMore,
        fetchMore: fetchMore
    }), isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        coverMode: true,
        view: "llama"
    }))));
};
FolderDropdownDesktop.displayName = 'FolderDropdownDesktop';
export default FolderDropdownDesktop;
